import { TrashIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { useBulkDeletePackages } from '@/api/packages/bulk-delete-packages'
import { ConfirmationPopup } from '@/components/ui/confirmation-popup'
import { Typography } from '@/components/ui/typography'
import { toastFactory } from '@/factories'
import { PackageModel } from '@/models'
import { getApiErrorMessage } from '@/utils'

import * as S from './bulk-delete-modal.styled'

export interface BulkDeleteModalProps {
  onClose: () => void
  packages: PackageModel[]
}

export const BulkDeleteModal = ({ onClose, packages }: BulkDeleteModalProps) => {
  const { t } = useTranslation(['packages'])
  const { mutateAsync: bulkDelete, isPending } = useBulkDeletePackages()
  const count = packages.length

  const handleConfirm = async () => {
    try {
      await bulkDelete({ ids: packages.map((pkg) => pkg.id) })
      toastFactory.success(t('packages:bulkDeleteModal.toastSuccess', { count }))
      onClose()
    } catch (error) {
      toastFactory.error(getApiErrorMessage(error))
    }
  }

  return (
    <ConfirmationPopup
      autoWidth
      title={t('packages:bulkDeleteModal.title', { count })}
      confirmText={t('packages:bulkDeleteModal.confirm')}
      cancelText={t('packages:bulkDeleteModal.cancel')}
      variant="danger"
      closeable={!isPending}
      closeOnOverlayClick={!isPending}
      closeOnEscapeKey={!isPending}
      confirmIcon={TrashIcon}
      onConfirm={handleConfirm}
      onClose={onClose}
    >
      <S.Container>
        <Typography size="text-huge" color="black700">
          {t('packages:bulkDeleteModal.body')}
        </Typography>
      </S.Container>
    </ConfirmationPopup>
  )
}
